import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

export function parseTime(time: string | Date): number {
  if (typeof time === 'string' && /^\d{2}:\d{2}$/.test(time)) {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  } else if (time instanceof Date) {
    return time.getHours() * 60 + time.getMinutes();
  }
  return NaN;
}

export function checkIfValidTime(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    let minutes: number;

    if (typeof value === 'string' && /^\d{2}:\d{2}$/.test(value)) {
      const parts = value.split(':');
      minutes = parseInt(parts[1], 10);
    } else if (value instanceof Date) {
      minutes = value.getMinutes();
    } else {
      return { invalidFormat: true };
    }

    if (minutes % 5 !== 0) {
      return { invalidTime: true };
    }

    return null;
  };
}

export const checkIfBackInTime: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const currentDate = new Date();
  const selectedDate = control.get('date')?.value;
  const endTime = control.get('endTime')?.value;
  const startTime = control.get('startTime')?.value;
  const today = DateTime.fromJSDate(currentDate).toSQLDate();
  const date = DateTime.fromJSDate(selectedDate).toSQLDate();
  if (currentDate && selectedDate && today == date) {
    const endMinutes = parseTime(endTime);
    const startMinutes = parseTime(startTime);
    const currentMinutes = parseTime(currentDate);
    if (startMinutes < currentMinutes) {
      return { startTimeInPast: true };
    }
  }
  return null;
};

export const checkIfEndTimeAfterStartTime: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const endTime = control.get('endTime')?.value;
  const startTime = control.get('startTime')?.value;

  if (!endTime || !startTime) {
    return null;
  }

  const endMinutes = parseTime(endTime);
  const startMinutes = parseTime(startTime);

  if (isNaN(endMinutes) || isNaN(startMinutes)) {
    return { invalidFormat: true };
  }

  if (endMinutes <= startMinutes) {
    return { endTimeNotAfterStartTime: true };
  }

  return null;
};

export function checkIfDateDifferenceIsValid(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dates = control.value;

    if (
      !Array.isArray(dates) ||
      dates.length !== 2 ||
      !(dates[0] instanceof Date) ||
      !(dates[1] instanceof Date)
    ) {
      return { invalidFormat: true };
    }

    const [startDate, endDate] = dates;
    const differenceInDays = Math.abs(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (differenceInDays >= 15) {
      return { dateDifferenceTooLarge: true };
    }

    return null;
  };
}
